module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_9.dc6e60c3ef5551f9b2b10a54a613935d.png";